const simpleMathFunction = (numbers, category) => {
  if (!Array.isArray(numbers) || numbers.length === 0) {
    return 0;
  }

  // Parse all numbers as floats
  const parsedNumbers = numbers.map((num) => parseFloat(num || 0));

  let result = parsedNumbers[0];

  for (let i = 1; i < parsedNumbers.length; i++) {
    switch (category) {
      case "addition":
        result += parsedNumbers[i];
        break;
      case "subtraction":
        result -= parsedNumbers[i];
        break;
      case "multiplication":
        result *= parsedNumbers[i];
        break;
      case "division":
        if (parsedNumbers[i] === 0) {
          throw new Error("Division by zero is not allowed.");
        }
        result /= parsedNumbers[i];
        break;
      default:
        throw new Error(
          'Invalid category. Use "addition", "subtraction", "multiplication", or "division".'
        );
    }
  }

  return result;
};

module.exports = simpleMathFunction;
